import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import {
    creativeTitleValidations,
    maxCreativeTitleLength,
    TITLE_WARNING_THRESHOLD,
    useInsignificantChangesValidation,
} from '../../config';
import { ContentEditableText } from '../ContentEditableText/ContentEditableText';

export const ContentTitle = ({
    id,
    placeholder,
    autoFocus,
    validations = creativeTitleValidations,
    validationDependencies,
    field = 'title',
    maxTitleLengthThreshold,
    ...rest
}) => {
    const isContentValidationEnabled = useConfigMatch({
        [FEATURE_FLAGS.AUTO_REVIEWER_CONTENT_VALIDATIONS_ENABLED]: 'true',
    });
    const finalValidations = useInsignificantChangesValidation({ baseValidations: validations });

    const {
        formAccount: { accountId },
    } = useFormDataContext();

    const finalValidationDependencies = useMemo(
        () => ({ isContentValidationEnabled, accountId, maxCreativeTitleLength, ...validationDependencies }),
        [isContentValidationEnabled, accountId, validationDependencies]
    );

    const maxThreshold = ((maxTitleLengthThreshold || TITLE_WARNING_THRESHOLD) - 1) / 100;

    return (
        <ContentEditableText
            id={id}
            field={field}
            autoFocus={autoFocus}
            placeholder={placeholder}
            hideDeleteButton
            validations={finalValidations}
            validationDependencies={finalValidationDependencies}
            maxLength={maxCreativeTitleLength}
            warningThreshold={maxThreshold}
            {...rest}
        />
    );
};

ContentTitle.propTypes = {
    id: PropTypes.string,
    status: PropTypes.string,
    existingTitles: PropTypes.array,
    autoFocus: PropTypes.bool,
    value: PropTypes.string,
    index: PropTypes.number,
    onChange: PropTypes.func,
    inputRef: PropTypes.func,
};
